import React, { useEffect } from "react";
import { useAppContext } from "../../context/appContext";

export default function DashboardLogoutPage() {

    const {accountController, setUserData, sessionId} = useAppContext();

    async function logout() {

        await accountController.logout(sessionId);

        setUserData(undefined);

        window.location.href = "/";

    }

    useEffect(() => {
        logout();
    }, []);

    return <a>Logging out...</a>;
}